import Vue from 'vue'
import permissions from './permissions/index'
import store from '@/services/store/store'

Vue.use(permissions, {
  store,
})
